import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

// import AddMeeting from './addmeeting/index'
import MeetingList from './meetinglist/index'
import AgendaList from './agendalist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const MeetingListProtected_ma = userIsCommitteeAdminRedir(MeetingList)
const AgendaListProtected_ma = userIsCommitteeAdminRedir(AgendaList)

const Archive = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Meeting Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/meeting-list`} />
            {/* <Route path={`${match.url}/add-meeting/:id?`} component={AddMeetingProtected_ma} /> */}
            <Route path={`${match.url}/archive-meeting-list/:id?`} component={MeetingListProtected_ma} />
            <Route path={`${match.url}/archive-agenda-list/:smeetingId?`} component={AgendaListProtected_ma} />
        </Switch>
    </div>
);

export default Archive;



// WEBPACK FOOTER //
// ./app/archivedetails/index.js